import type { Customer } from "./types";

export const initialCustomers: Customer[] = [
  { id: "c1", name: "Priya Sharma", email: "priya@email.com", orders: 6, spent: 28500 },
  { id: "c2", name: "Sneha Verma", email: "sneha@email.com", orders: 3, spent: 11200 },
  { id: "c3", name: "Ananya Rao", email: "ananya@email.com", orders: 2, spent: 6800 },
  { id: "c4", name: "Isha Singh", email: "isha@email.com", orders: 4, spent: 12300 },
  { id: "c5", name: "Radhika Jain", email: "radhika@email.com", orders: 1, spent: 2100 },
  { id: "c6", name: "Kavya Nair", email: "kavya@email.com", orders: 5, spent: 19000 },
];
